import './style/registerForm.scss';

import React, { FocusEventHandler, MouseEventHandler } from 'react';
import {RegisterErrors} from "../../../util/types";
import { ChangeFunction, DvrdButton, DvrdDatePicker, DvrdInput, Loader, preventDefault } from "@dvrd/dvr-controls";
import IDate from "@dvrd/idate";

interface Props {
    onChangeNameOne: ChangeFunction<string>;
    onChangeDobOne: ChangeFunction<IDate | null>;
    onChangeNameTwo: ChangeFunction<string>;
    onChangeDobTwo: ChangeFunction<IDate | null>;
    onChangeNameParentOne: ChangeFunction<string>;
    onChangeTelParentOne: ChangeFunction<string>;
    onChangeEmailParentOne: ChangeFunction<string>;
    onChangeNameParentTwo: ChangeFunction<string>;
    onChangeTelParentTwo: ChangeFunction<string>;
    onChangeEmailParentTwo: ChangeFunction<string>;
    onChangeAddress: ChangeFunction<string>;
    onChangeZipCode: ChangeFunction<string>;
    onChangeCity: ChangeFunction<string>;
    onChangeOtherRegistrars: ChangeFunction<string>;
    onResetError: (key: keyof RegisterErrors) => FocusEventHandler;
    onSubmit: MouseEventHandler;
    nameOne: string;
    dobOne: IDate | null;
    nameTwo: string;
    dobTwo: IDate | null;
    nameParentOne: string;
    telParentOne: string;
    emailParentOne: string;
    nameParentTwo: string;
    telParentTwo: string;
    emailParentTwo: string;
    address: string;
    zipCode: string;
    city: string;
    otherRegistrars: string;
    errors: RegisterErrors;
    loading: boolean;
}

export default function RegisterForm(props: Props) {
    const {
        onChangeNameOne, onChangeDobOne, onChangeNameTwo, onChangeDobTwo, onChangeNameParentOne, onChangeTelParentOne,
        onChangeEmailParentOne, onChangeNameParentTwo, onChangeTelParentTwo, onChangeEmailParentTwo, onChangeAddress,
        onChangeZipCode, onChangeCity, onChangeOtherRegistrars, onResetError, onSubmit, nameOne, dobOne, nameTwo,
        dobTwo, nameParentOne, telParentOne, emailParentOne, nameParentTwo, telParentTwo, emailParentTwo, address,
        zipCode, city, otherRegistrars, errors, loading
    } = props;

    function renderFormField(label: string, value: string, onChange: ChangeFunction<string>,
                             config?: {errorKey?: keyof RegisterErrors; inputType?: 'email' | 'tel'}) {
        const errorKey = config?.errorKey;
        const error = !!errorKey ? errors[errorKey] : undefined;
        const onFocus = !!errorKey ? onResetError(errorKey) : undefined;
        return (
            <DvrdInput value={value} label={label} onChange={onChange} error={error} onFocus={onFocus}
                       type={config?.inputType}/>
        );
    }
    const childTwoRequired = nameTwo.length || !!dobTwo;
    return (
        <form className='register-form-container' onSubmit={preventDefault}>
            <Loader active={loading}/>
            {renderFormField('Voor- en achternaam 1e kind *', nameOne, onChangeNameOne, {errorKey: 'nameOne'})}
            <DvrdDatePicker value={dobOne} onChange={onChangeDobOne} label='Geboortedatum 1e kind *'
                            dateFormat='DD-MM-YYYY' error={errors.dobOne} placeholder='dd-mm-jjjj'
                            alwaysShowArrows closeOnChange/>

            {renderFormField('Naam ouder 1 *', nameParentOne, onChangeNameParentOne, {errorKey: 'nameParentOne'})}
            {renderFormField('Telefoonnummer ouder 1 *', telParentOne, onChangeTelParentOne,
                {errorKey: 'telParentOne', inputType: 'tel'})}
            {renderFormField('E-mailadres ouder 1 *', emailParentOne, onChangeEmailParentOne,
                {errorKey: 'emailParentOne', inputType: 'email'})}
            {renderFormField('Naam ouder 2', nameParentTwo, onChangeNameParentTwo)}
            {renderFormField('Telefoonnummer ouder 2', telParentTwo, onChangeTelParentTwo, {inputType: 'tel'})}
            {renderFormField('E-mailadres ouder 2', emailParentTwo, onChangeEmailParentTwo, {inputType: 'email'})}
            {renderFormField('Adres *', address, onChangeAddress, {errorKey: 'address'})}
            {renderFormField('Postcode *', zipCode, onChangeZipCode, {errorKey: 'zipCode'})}
            {renderFormField('Woonplaats *', city, onChangeCity, {errorKey: 'city'})}
            {renderFormField('Heeft u al een zoon of dochter bij ons ingeschreven?', otherRegistrars,
                onChangeOtherRegistrars)}
            {renderFormField(`Voor- en achternaam 2e kind${childTwoRequired ? ' *' : ''}`, nameTwo, onChangeNameTwo,
                {errorKey: 'nameTwo'})}
            <DvrdDatePicker value={dobTwo} onChange={onChangeDobTwo}
                            label={`Geboortedatum 2e kind${childTwoRequired ? ' *' : ''}`}
                            dateFormat='DD-MM-YYYY' error={errors.dobTwo} placeholder='dd-mm-jjjj'
                            alwaysShowArrows closeOnChange/>
            <DvrdButton onClick={onSubmit} label='Versturen' className='btn-submit'/>
        </form>
    )
}